import { Typography } from '@mui/material';
import styled, { css } from 'styled-components';
import { MarginsHandler, MarginSpacing } from '../../../commons/styles/spacing';

const StTypography = styled(Typography)<{ $margin?: MarginSpacing }>`
  ${MarginsHandler}
  line-height: ${({ lineHeight }) => `${lineHeight || 1}`};

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `}
`;

export { StTypography };
